"use client";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ProductCard from "../components/ProductCard";
import { Modal } from "react-bootstrap";

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://app.andosa.org/catgoreis/get-catgoreis"
        );
        const data = await response.json();
        if (Array.isArray(data.catogrey)) {
          setCategories(data.catogrey);
        } else {
          console.error("بيانات الفئات غير صالحة");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://app.andosa.org/product/get-products"
        );
        const data = await response.json();
        if (Array.isArray(data.product)) {
          setProducts(data.product);
        } else {
          console.error("Invalid product data");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    Promise.all([fetchCategories(), fetchProducts()]).finally(() =>
      setLoading(false)
    );
  }, []);

  const filteredProducts = useMemo(() => {
    return selectedCategory
      ? products.filter((product) => product.catgory_id === selectedCategory)
      : products;
  }, [selectedCategory, products]);

  const handleCategoryClick = useCallback(
    (categoryId) => {
      if (categoryId === selectedCategory) {
        setSelectedCategory("");
      } else {
        setSelectedCategory(categoryId);
      }
    },
    [selectedCategory]
  );

  const handleShowModal = useCallback((product) => {
    setSelectedProduct(product);
    setShowModal(true);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const getImageUrl = (imageUrl) => {
    if (imageUrl.startsWith("Images\\")) {
      return `https://app.andosa.org/images/${imageUrl
        .replace("Images\\", "")
        .replace(/\\/g, "/")}`;
    }
    return imageUrl;
  };

  return (
    <div
      className="container mt-4"
      style={{ fontFamily: "'Baloo Bhaijaan 2'" }}
    >
      {loading ? (
        <div className="text-center">
          <h3>جاري التحميل...</h3>
        </div>
      ) : (
        <>
          <div className="mb-4">
            <h4 className="pb-3 pt-5" style={{ textAlign: "right" }}>
              اقسام اطلب
            </h4>
            <div className="row">
              {categories.map((category) => (
                <div key={category.id} className="col-md-2 mb-3">
                  <div
                    className={`card ${
                      selectedCategory === category.id
                        ? "border-primary"
                        : "border-secondary"
                    }`}
                    onClick={() => handleCategoryClick(category.id)}
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                      textAlign: "center",
                      padding: "10px",
                      height: "200px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={getImageUrl(category.image)}
                      alt={category.name}
                      className="card-img-top"
                      width={200}
                      height={120}
                      style={{
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                    />
                    <div className="card-body">
                      <h5 className="card-title" style={{ fontSize: "14px" }}>
                        {category.name}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            {filteredProducts.length === 0 && products.length === 0 && (
              <div className="col-12 text-center">
                <h3>لا توجد منتجات</h3>
              </div>
            )}
            {filteredProducts.length === 0 && selectedCategory && (
              <div className="col-12 text-center">
                <h3>لا توجد منتجات في هذه الفئة</h3>
              </div>
            )}
            <h5 className="pb-3" style={{ textAlign: "right" }}>
              الاكثر رواجا في اطلب
            </h5>
            {filteredProducts.length > 0 &&
              filteredProducts.map((product) => (
                <div key={product.id} className="col-md-3 mb-3">
                  <ProductCard
                    product={product}
                    onClick={() => handleShowModal(product)}
                  />
                </div>
              ))}
          </div>

          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
            size="lg"
            style={{ fontFamily: "'Baloo Bhaijaan 2'" }}
          >
            <Modal.Body>
              <div className="row">
                <div className="col-md-6">
                  <div className="text-center mb-3">
                    <img
                      src={getImageUrl(
                        selectedProduct?.image || "/images/placeholder.png"
                      )}
                      alt={selectedProduct?.name || "منتج غير محدد"}
                      className="img-fluid"
                      width={500}
                      height={500}
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                </div>
                <div className="col-md-6 pt-5">
                  <h5 className="mb-3">تفاصيل المنتج</h5>
                  <p>
                    <strong>اسم المنتج:</strong>{" "}
                    {selectedProduct?.name || "غير محددة"}
                  </p>
                  <p>
                    <strong>السعر:</strong> ${selectedProduct?.price || "0"}
                  </p>
                  <p>
                    {selectedProduct?.description ||
                      "لا توجد تفاصيل متاحة لهذا المنتج."}
                  </p>
                  <div className="d-flex pt-5">
                    <a
                      href="tel:0700645972"
                      className="btn btn-primary w-100 mt-3"
                      style={{ marginLeft: "20px" }}
                    >
                      اتصل بنا <i className="bi bi-telephone me-3"></i>
                    </a>
                    <a
                      href="https://wa.me/+447506403424"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success w-100 mt-3"
                    >
                      واتساب <i className="bi bi-whatsapp me-3"></i>{" "}
                    </a>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Home;
